import {Template, Ticket} from "../types/commonTypes";

export default class TicketListApiClient{
     GetTicketsApi = async (): Promise<Ticket[]> => {
        let tickets: Ticket[] = [];
        const url = "/tickets/api/list";
        await fetch(url)
            .then(response => response.json())
            .then((data) => {
                if (data != undefined && data['tickets'] != undefined)
                    tickets = data['tickets'];
            }).catch(error => {
                console.log(error);
                throw error.message;
            });
        return tickets;
    };

    CreateTicketApi = async (data) => {
        const url = "/tickets/api/";
        let response = {};
        await fetch(url,{
            method: 'POST',
            body: data,
            headers: new Headers({'content-type': 'application/json'})
        }).then((response) => {
                 if(response.ok)
                     return response.json();
                 throw new Error(response.statusText);
            }).then((data) => {
                response = data;
                console.log(data)
            }).catch(   error => {
                // TODO: This isn't a great user experience
                console.log("[ERROR] Unable to create ticket due to "+error);
            });
        return response;
    };

    postTicketAnnouncement = async (ticketId: string, data) => {
        let response = {};
        const url = `/tickets/api/${ticketId}/announcement`;
        await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: data
        })
            .then(response => response.json())
            .then((data) => {
                console.log(data)
            }).catch(error => {
                // TODO: This isn't a great user experience
                console.log(error);
            });
        return response;
    };

    getTemplateApi = async (templateId:string) => {
        let template: Template = {}
        const url = `/tickets/api/template/${templateId}`;
        await fetch(url)
            .then(response => response.json())
            .then((data) => {
                if(data != undefined){
                    template.templateId = data['templateId']
                    template.templateTitle = data['templateTitle']
                    template.description = data['description']
                }
            },(error) => {
                // TODO: This isn't a great user experience
                console.log(error);
            });
        return template;
    }

    getTicketCategories = async () => {
        const url = "/tickets/api/categories"
        const response = await fetch(url)
        return response.json()
    }
};

